import { render, staticRenderFns } from "./HomeTab.vue?vue&type=template&id=c43c1a58&scoped=true"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"
import style0 from "./HomeTab.vue?vue&type=style&index=0&id=c43c1a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43c1a58",
  null
  
)

export default component.exports